import api from "../services/api";
import {
  CustomRegistrationFieldDTO,
  CreateCustomRegistrationFieldDTO,
  UpdateCustomRegistrationFieldDTO,
  TeamMemberCustomFieldsDTO,
  SubmitCustomFieldValuesDTO,
  UpdateCustomFieldValueDTO,
} from "../models/ICustomRegistrationField";
import { IServiceResponse } from "../types/api";

// Field Definition Endpoints (Admin)

export const getFieldsByCategory = (
  tournamentCategoryMappingId: string
): Promise<IServiceResponse<CustomRegistrationFieldDTO[]>> =>
  api.get(`custom-registration-fields/category/${tournamentCategoryMappingId}`);

export const getFieldById = (
  fieldId: string
): Promise<IServiceResponse<CustomRegistrationFieldDTO>> =>
  api.get(`custom-registration-fields/${fieldId}`);

export const createCustomRegistrationField = (
  tournamentCategoryMappingId: string,
  data: CreateCustomRegistrationFieldDTO
): Promise<IServiceResponse<CustomRegistrationFieldDTO>> =>
  api.post(`custom-registration-fields/category/${tournamentCategoryMappingId}`, data);

export const updateCustomRegistrationField = (
  fieldId: string,
  data: UpdateCustomRegistrationFieldDTO
): Promise<IServiceResponse<CustomRegistrationFieldDTO>> =>
  api.put(`custom-registration-fields/${fieldId}`, data);

export const deleteCustomRegistrationField = (
  fieldId: string
): Promise<IServiceResponse<boolean>> =>
  api.delete(`custom-registration-fields/${fieldId}`);

export const reorderFields = (
  tournamentCategoryMappingId: string,
  fieldIds: string[]
): Promise<IServiceResponse<boolean>> =>
  api.put(`custom-registration-fields/category/${tournamentCategoryMappingId}/reorder`, fieldIds);

// Field Value Endpoints (Registration)

export const getFieldValuesForTeamMember = (
  teamMemberId: string
): Promise<IServiceResponse<TeamMemberCustomFieldsDTO>> =>
  api.get(`custom-registration-fields/values/team-member/${teamMemberId}`);

export const getFieldValuesForCategory = (
  tournamentCategoryMappingId: string
): Promise<IServiceResponse<TeamMemberCustomFieldsDTO[]>> =>
  api.get(`custom-registration-fields/values/category/${tournamentCategoryMappingId}`);

export const submitFieldValues = (
  data: SubmitCustomFieldValuesDTO
): Promise<IServiceResponse<boolean>> =>
  api.post(`custom-registration-fields/values`, data);

export const updateFieldValue = (
  fieldValueId: string,
  data: UpdateCustomFieldValueDTO
): Promise<IServiceResponse<boolean>> =>
  api.put(`custom-registration-fields/values/${fieldValueId}`, data);

export const validateRequiredFields = (
  teamMemberId: string
): Promise<IServiceResponse<string[]>> =>
  api.get(`custom-registration-fields/values/validate/${teamMemberId}`);

